// MediaGrid.js
import React from "react";
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  arrayMove,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { XCircle } from "lucide-react";

const SortableItem = ({ media, onRemove }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: media.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    width: 80,
    height: 80,
    position: "relative",
    marginRight: 10,
    borderRadius: 8,
    overflow: "hidden",
    cursor: "grab",
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {media.mediaType === "image" ? (
        <img src={media.previewUrl} alt="img" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      ) : (
        <video src={media.previewUrl} muted style={{ width: "100%", height: "100%" }} />
      )}
      <button
       onClick={(e) => {
        e.stopPropagation(); // 👉 important: stops DnD from interfering
        onRemove(media.id);  // 👉 call delete
      }}
        style={{
          position: "absolute",
          top: 2,
          right: 2,
          background: "rgba(0,0,0,0.6)",
          color: "white",
          border: "none",
          borderRadius: "50%",
        }}
      >
        <XCircle size={16} />
      </button>
    </div>
  );
};

const MediaGrid = ({ mediaFiles, setMediaFiles }) => {
  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = mediaFiles.findIndex((m) => m.id === active.id);
      const newIndex = mediaFiles.findIndex((m) => m.id === over.id);
      const newOrder = arrayMove(mediaFiles, oldIndex, newIndex);
      setMediaFiles(newOrder);
    }
  };

  const handleRemove = (id) => {
    setMediaFiles((prev) => prev.filter((m) => m.id !== id));
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={mediaFiles.map((m) => m.id)} strategy={horizontalListSortingStrategy}>
        <div style={{ display: "flex", alignItems: "center", padding: 10 }}>
          {mediaFiles.map((media) => (
            <SortableItem key={media.id} media={media} onRemove={handleRemove} />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  );
};

export default MediaGrid;
